import { render, staticRenderFns } from "./Sizhuadmin.vue?vue&type=template&id=bac56966&scoped=true"
import script from "./Sizhuadmin.vue?vue&type=script&lang=js"
export * from "./Sizhuadmin.vue?vue&type=script&lang=js"
import style0 from "./Sizhuadmin.vue?vue&type=style&index=0&id=bac56966&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac56966",
  null
  
)

export default component.exports